const en: Record<string, Record<string, string>> = {
  playerControls: {
    mute: 'Mute',
    unmute: 'Unmute',
    play: 'Play',
    pause: 'Pause'
  },
  errors: {
    noVideoId: 'No Video Provided',
    noVideoDescription: 'If you\'re seeing this, please contact platform support.',
  }
}

export default en;